export const LS_CART_KEY = 'guestCartItems';
